<template>
  <div class="box-contact-detail">
    <div class="header">
      <div class="font-weight-700 full-width">
        {{ $t('contacts.answer') }} ({{ data.quantity_message }})
      </div>
      <div class="btn-contact-detail">
        <el-button class="btn btn-comment" @click="comment" v-if="status != $statusContact.solved">
          {{ $t('contacts.buttons.comment') }}
        </el-button>
        <el-button class="btn btn-resolve" @click="resolve" v-if="status != $statusContact.solved">
          {{ $t('contacts.buttons.resolve') }}
        </el-button>
        <el-button class="btn btn-cancle" @click="unresolve" v-if="status == $statusContact.solved">
          {{ $t('contacts.buttons.unresolve') }}
        </el-button>
      </div>
    </div>
    <list-message-admin
      :messages="messages"
      :contact="contact"
      v-if="site != $siteType.site_partner"
    >
    </list-message-admin>
    <list-message-partner
      :messages="messages"
      :contact="contact"
      v-if="site === $siteType.site_partner"
    >
    </list-message-partner>
    <img class="icon-reply" src="/images/reply.svg" @click="comment" v-if="status != $statusContact.solved"/>
    <dialog-comment
      v-if="openPopupComment"
      :openFormComment="true"
      :urls="urls"
      :lastMessage="lastMessage"
      :newMessage="newMessage"
      @is-close-popup-comment="handleClosePopupComment"
      @confirm-new-message="confirmNewMessage"
    >
    </dialog-comment>
    <dialog-confirm-comment
      v-if="openPopupConfirmComment"
      :openFormConfirmComment="true"
      :urls="urls"
      :contactId="contact.id"
      :lastMessage="lastMessage"
      :message="newMessage"
      :site="site"
      @is-close-popup-confirm-comment="closePopupConfirmComment"
      @send-message-complete="showMessageComplete"
    >
    </dialog-confirm-comment>
    <dialog-send-message-complete
      v-if="openPopupSendMessgeComplete"
      :openPopupSendMessgeComplete="true"
      @close-popup-send-message-complete="closePopupSendCommentComplete"
    >
    </dialog-send-message-complete>
    <dialog-resolve-contact
      v-if="openDialogResolveContact"
      :openDialogResolveContact="true"
      :lastMessage="lastMessage"
      :urls="urls"
      @close-popup-resolve="closePopupResolve"
      @resolve-complete="resolveComplete"
    >
    </dialog-resolve-contact>
    <dialog-unresolve-contact
      v-if="openDialogUnresolveContact"
      :openDialogUnresolveContact="true"
      :lastMessage="lastMessage"
      :urls="urls"
      @close-popup-unresolve="closePopupUnresolve"
      @unresolve-complete="unresolveComplete"
    >
    </dialog-unresolve-contact>
  </div>
</template>

<script>
  import { getListMessage } from '../../api/contact'
  export default {
    emits: ['statusLabel'],
    props: {
      contact: { type: Object, required: true, default: {} },
      urls: { type: Object, required: true, default: {} },
      site: { type: Number, required: false },
    },

    data() {
      return {
        newMessage: '',
        openPopupComment: false,
        openPopupConfirmComment: false,
        openPopupSendMessgeComplete: false,
        openDialogResolveContact: false,
        openDialogUnresolveContact: false,
        status: 0,
        messages: {},
        data: {}
      }
    },

    methods: {
      comment() {
        this.openPopupComment = true;
      },

      resolve() {
        this.openDialogResolveContact = true;
      },

      unresolve() {
        this.openDialogUnresolveContact = true;
      },

      handleClosePopupComment() {
        this.openPopupComment = false;
        this.newMessage = '';
      },

      closePopupConfirmComment() {
        this.openPopupComment = true;
        this.openPopupConfirmComment = false;
      },

      confirmNewMessage(newMessage) {
        this.newMessage = newMessage;
        this.openPopupComment = false;
        this.openPopupConfirmComment = true;
      },

      showMessageComplete(status) {
        this.newMessage = '';
        this.openPopupConfirmComment = false;
        this.openPopupSendMessgeComplete = true;
        this.status = status;
        this.getListMessage();
      },

      closePopupSendCommentComplete() {
        this.openPopupSendMessgeComplete = false;
      },

      closePopupResolve() {
        this.openDialogResolveContact = false;
      },

      closePopupUnresolve() {
        this.openDialogUnresolveContact = false;
      },

      getListMessage() {
        getListMessage(this.urls.data)
        .then(response => response.json())
        .then(response => {
          this.data = response.data;
          this.messages = response.data.messages
          this.$emit('statusLabel', this.status, this.data.status_label);
        })
      },

      resolveComplete(statusLabel) {
        this.openDialogResolveContact = false;
        this.status = this.$statusContact.solved;
        this.$emit('statusLabel', this.$statusContact.solved, statusLabel);
      },

      unresolveComplete(status, statusLabel) {
        this.openDialogUnresolveContact = false;
        this.status = status;
        this.$emit('statusLabel', status, statusLabel);
      }
    },

    computed: {
      lastMessage() {
        return (this.data.last_message_form_contacter) ? this.data.last_message_form_contacter.message : '';
      }
    },

    created() {
      this.status = this.contact.status;
      this.getListMessage();
    }
  }
</script>

<style lang="scss" scoped>
  .box-contact-detail {
    .list-message{
      height: 500px;
      overflow-y: auto;
      .box-messages {
        .sender {
          padding: 25px;
          font: normal normal normal 13px/29px Kozuka Gothic Pr6N;
          letter-spacing: 1.3px;
          color: #000000;
        }
        .message-from  {
          position: relative;
          margin-left: 20px;
          margin-bottom: 10px;
          padding: 10px;
          background-color: #FFFFFF;
          max-width: 700px;
          height: auto;
          text-align: left;
          font: normal normal normal 13px/29px Kozuka Gothic Pr6N;
          letter-spacing: 1.3px;
          color: #000000;
          border: 1px solid #CBBFAD;
          border-radius: 20px;
          ::before {
            content: '';
            position: absolute;
            visibility: visible;
            top: 25px;
            left: -40px;
            border-left: 40px solid transparent;
            border-top: 50px solid #CBBFAD;
          }
          ::after {
            content: '';
            position: absolute;
            visibility: visible;
            top: 26px;
            left: -39px;
            border-left: 40px solid transparent;
            border-top: 49px solid white;
            clear: both;
          }
        }
        .message-reply {
          position: relative;
          margin-right: 30px;
          margin-bottom: 10px;
          padding: 10px;
          background-color: #F7F3ED;
          max-width: 700px;
          height: auto;
          text-align: left;
          font: normal normal normal 13px/29px Kozuka Gothic Pr6N;
          letter-spacing: 1.3px;
          color: #000000;
          border: 1px solid #F7F3ED;
          border-radius: 20px;
          ::before {
            content: '';
            position: absolute;
            visibility: visible;
            top: 25px;
            right: -40px;
            border-right: 40px solid transparent;
            border-top: 50px solid #F7F3ED;
          }
          ::after {
            content: '';
            position: absolute;
            visibility: visible;
            top: 26px;
            right: -39px;
            border-right: 40px solid transparent;
            border-top: 49px solid #F7F3ED;
            clear: both;
          }
        }
        .el-avatar {
          --el-avatar-bg-color: #F7F3ED;
        }
      }
    }
    .btn-contact-detail {
      margin-top: 20px;
      margin-bottom: 20px;
      .btn {
        width: 157px;
        height: 35px;
        font: normal normal normal 13px/29px Kozuka Gothic Pr6N;
        letter-spacing: 1.3px;
        color: #FFFFFF;
        margin-left: 25px;
        &:first-child {
          margin-left: 0;
        }
      }
      .btn-comment {
        background: #AC3B29 0% 0% no-repeat padding-box;
      }
      .btn-resolve {
        background: #468349 0% 0% no-repeat padding-box;
      }
      .btn-cancle {
        background: #969696 0% 0% no-repeat padding-box;
      }
    }
    .icon-reply {
      width: 65px;
      height: 65px;
      bottom: 35px;
      position: fixed;
      right: 15px;
      cursor: pointer;
    }
  }
</style>
